<template>
  <label
    class="cursor-pointer leading-relaxed"
    :class="{ 'font-bold': checkboxItem.isRefined }"
  >
    <CheckBox
      :is-checked="checkboxItem.isRefined"
      @change="handleChange(checkboxItem)"
    />
    <span class="text-sm">
      {{ refinementListItemLabel }}
    </span>
    <FacetCount :item="checkboxItem" />
  </label>
</template>

<script lang="ts">

import type { RefinementListItem } from 'vue-instantsearch/vue3/es';

import { FILTERS_INTERACTIONS } from '~~/constants/googleTagManager';

export default defineComponent({
  name: 'CheckboxPickerOption',

  props: {
    checkboxItem: {
      type: Object as PropType<RefinementListItem>,
      required: true,
    },
    refine: {
      type: Function as PropType<(value: string) => void>,
      required: true,
    },
    translateAttributes: {
      type: Boolean,
      default: false,
    },
    facet: {
      type: String,
      required: true,
    },
  },
  setup (props) {

    const { getTypesenseFilterName } = useTypesense();
    const { callClickFilterEvent } = useClickFiltersEvent();

    const refinementListItemLabel = computed(() =>
      getTypesenseFilterName(props.checkboxItem.value),
    );

    const handleChange = (item: RefinementListItem) => {

      const filterInteraction =
        props.checkboxItem.isRefined ? FILTERS_INTERACTIONS.FILTER_UNSELECT : FILTERS_INTERACTIONS.FILTER_SELECT;

      callClickFilterEvent({
        filterInteraction,
        filterSection: props.facet,
        filterName: refinementListItemLabel.value.toString(),
        filterValue: item.value,
      });
      props.refine(item.value);

    };

    return {
      refinementListItemLabel,
      handleChange,
    };

  },
});

</script>
